module.exports = __webpack_public_path__ + "static/img/logonnhfy.7cf9719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nhfy/logonnhfy.jpg
// module id = E9GM
// module chunks = 2